const reportsList = [
  { name: 'history', enable: true, label: 'History' },
  { name: 'fuel', enable: true, label: 'Fuel' },
  { name: 'mileage', enable: true, label: 'Mileage' },
  { name: 'notification', enable: true, label: 'Notification' },
  { name: 'alarm', enable: true, label: 'Alarm' },
  { name: 'fuelReceipt', label: 'Fuel Receipt', enable: true },
  { name: 'tollReceipt', label: 'Toll Receipt', enable: true },
  { name: 'input', enable: true, label: 'Input' },
  { name: 'input2', enable: true, label: 'Input 2' },
  { name: 'input3', enable: true, label: 'Input 3' },
  { name: 'summary', enable: true, label: 'Summary' },
  { name: 'temperature', enable: true, label: 'Temperature' },
  { name: 'maintenanceLog', label: 'Maintenance Log', enable: true },
  { name: 'historyWatch', enable: true, label: 'History - Watch' },
  { name: 'poiWatch', enable: true, label: 'POI - Watch' },
  { name: 'poi', enable: true, label: 'POI' },
  { name: 'fatigue', enable: true, label: 'Fatigue Driving' },
];

export { reportsList };
